import { createContext } from "react"

export interface AppContextValue {
  chatId: number | null
  devMode: boolean
  isInitialized: boolean
  tabParam: string | null
  reportId: string | null
  captchaMode: boolean
  joinRequestAttemptId: string | null
  userId: number | null
  autoMessageId: number | null
  shareToken: string | null
  setChatId: (chatId: number | null) => void
  clearTabParam: () => void
  clearAutoMessageId: () => void
}

export const AppContext = createContext<AppContextValue | undefined>(undefined)
